import type { QueryClient } from '@tanstack/react-query'
import { fetchCustomViews } from '@/api/customViewsApi'
import { saveAllCustomViews } from '@/db/viewerDb'
import { useAppStore } from '@/store/appStore'

export async function reloadCustomViews(): Promise<void> {
  const response = await fetchCustomViews()
  await saveAllCustomViews(response.customViews)
  const { setCustomViews, setPendingCustomViews } = useAppStore.getState()
  setCustomViews(response.customViews)
  setPendingCustomViews(response.pendingCustomViews ?? [])
}

// A share endpoint answering 404 may mean sharing was switched off after this bundle loaded.
// Refetching the bundle and views lets the UI drop sharing silently instead of showing an error.
export async function refreshSharingState(queryClient: QueryClient): Promise<void> {
  await Promise.allSettled([
    queryClient.invalidateQueries({ queryKey: ['content-bundle'] }),
    queryClient.invalidateQueries({ queryKey: ['content-bundle-draft'] }),
    reloadCustomViews(),
  ])
}
